import React, { useState } from 'react';
import { FilterXIcon, SidebarIcon, StarIcon } from 'lucide-react';
const TeamsTable = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [filters, setFilters] = useState({
    league: '',
    searchQuery: '',
    showFavorites: false,
    winPercentage: [0, 100],
    offenseRating: [0, 100],
    defenseRating: [0, 100],
    threePtPercentage: [0, 100]
  });
  const [favoriteTeams, setFavoriteTeams] = useState<string[]>([]);
  const leagues = ['NBA', 'Euroleague', 'Liga ACB', 'LNB Pro A'];
  const teams = [{
    name: 'Boston Celtics',
    logo: 'https://content.sportslogos.net/logos/6/213/thumbs/slhg02hbef3j1ov4lsnwyol5o.gif',
    stats: {
      winPercentage: 85.2,
      offenseRating: 92.4,
      defenseRating: 88.7,
      threePtPercentage: 78.5,
      assistsPerGame: 82.3,
      reboundsPerGame: 75.8
    },
    conference: 'Eastern',
    division: 'Atlantic'
  }, {
    name: 'Milwaukee Bucks',
    logo: 'https://content.sportslogos.net/logos/6/225/thumbs/22582752016.gif',
    stats: {
      winPercentage: 82.4,
      offenseRating: 89.8,
      defenseRating: 86.5,
      threePtPercentage: 75.2,
      assistsPerGame: 79.8,
      reboundsPerGame: 77.4
    },
    conference: 'Eastern',
    division: 'Central'
  }, {
    name: 'Los Angeles Lakers',
    logo: 'https://content.sportslogos.net/logos/6/237/thumbs/uig7aiht8jnpl1szbi57zzlsh.gif',
    stats: {
      winPercentage: 65.8,
      offenseRating: 85.2,
      defenseRating: 82.1,
      threePtPercentage: 72.3,
      assistsPerGame: 76.5,
      reboundsPerGame: 79.2
    },
    conference: 'Western',
    division: 'Pacific'
  }, {
    name: 'Denver Nuggets',
    logo: 'https://content.sportslogos.net/logos/6/229/thumbs/22989262019.gif',
    stats: {
      winPercentage: 79.6,
      offenseRating: 88.9,
      defenseRating: 85.4,
      threePtPercentage: 76.8,
      assistsPerGame: 84.2,
      reboundsPerGame: 73.5
    },
    conference: 'Western',
    division: 'Northwest'
  }, {
    name: 'Miami Heat',
    logo: 'https://content.sportslogos.net/logos/6/214/thumbs/burm5gh2wvjti3xhei5h16k8e.gif',
    stats: {
      winPercentage: 71.5,
      offenseRating: 83.7,
      defenseRating: 84.9,
      threePtPercentage: 74.1,
      assistsPerGame: 77.8,
      reboundsPerGame: 72.9
    },
    conference: 'Eastern',
    division: 'Southeast'
  }, {
    name: 'Phoenix Suns',
    logo: 'https://content.sportslogos.net/logos/6/238/thumbs/23843702014.gif',
    stats: {
      winPercentage: 73.2,
      offenseRating: 86.4,
      defenseRating: 83.2,
      threePtPercentage: 75.6,
      assistsPerGame: 78.9,
      reboundsPerGame: 71.4
    },
    conference: 'Western',
    division: 'Pacific'
  }, {
    name: 'Philadelphia 76ers',
    logo: 'https://content.sportslogos.net/logos/6/218/thumbs/21870342016.gif',
    stats: {
      winPercentage: 68.9,
      offenseRating: 84.5,
      defenseRating: 85.7,
      threePtPercentage: 71.8,
      assistsPerGame: 75.4,
      reboundsPerGame: 74.8
    },
    conference: 'Eastern',
    division: 'Atlantic'
  }, {
    name: 'Golden State Warriors',
    logo: 'https://content.sportslogos.net/logos/6/235/thumbs/23531522020.gif',
    stats: {
      winPercentage: 70.4,
      offenseRating: 87.8,
      defenseRating: 81.9,
      threePtPercentage: 77.9,
      assistsPerGame: 83.6,
      reboundsPerGame: 70.2
    },
    conference: 'Western',
    division: 'Pacific'
  }, {
    name: 'Dallas Mavericks',
    logo: 'https://content.sportslogos.net/logos/6/228/thumbs/22834632018.gif',
    stats: {
      winPercentage: 67.3,
      offenseRating: 85.9,
      defenseRating: 80.4,
      threePtPercentage: 73.7,
      assistsPerGame: 76.2,
      reboundsPerGame: 69.8
    },
    conference: 'Western',
    division: 'Southwest'
  }, {
    name: 'Cleveland Cavaliers',
    logo: 'https://content.sportslogos.net/logos/6/222/thumbs/22269212018.gif',
    stats: {
      winPercentage: 66.8,
      offenseRating: 82.3,
      defenseRating: 84.6,
      threePtPercentage: 70.5,
      assistsPerGame: 74.8,
      reboundsPerGame: 73.1
    },
    conference: 'Eastern',
    division: 'Central'
  }, {
    name: 'New York Knicks',
    logo: 'https://content.sportslogos.net/logos/6/216/thumbs/2nn48xofg0hms8k326cqdmuis.gif',
    stats: {
      winPercentage: 64.5,
      offenseRating: 81.7,
      defenseRating: 83.9,
      threePtPercentage: 69.4,
      assistsPerGame: 73.2,
      reboundsPerGame: 75.6
    },
    conference: 'Eastern',
    division: 'Atlantic'
  }, {
    name: 'LA Clippers',
    logo: 'https://content.sportslogos.net/logos/6/236/thumbs/23654622016.gif',
    stats: {
      winPercentage: 69.1,
      offenseRating: 84.8,
      defenseRating: 82.5,
      threePtPercentage: 72.8,
      assistsPerGame: 75.9,
      reboundsPerGame: 72.4
    },
    conference: 'Western',
    division: 'Pacific'
  }];
  const resetFilters = () => {
    setFilters({
      league: '',
      searchQuery: '',
      showFavorites: false,
      winPercentage: [0, 100],
      offenseRating: [0, 100],
      defenseRating: [0, 100],
      threePtPercentage: [0, 100]
    });
  };
  const toggleFavorite = (teamName: string) => {
    setFavoriteTeams(prev => prev.includes(teamName) ? prev.filter(name => name !== teamName) : [...prev, teamName]);
  };
  const getStatColor = (value: number) => {
    if (value >= 80) return 'bg-green-500';
    if (value >= 70) return 'bg-green-400';
    if (value >= 60) return 'bg-yellow-400';
    if (value >= 50) return 'bg-orange-400';
    return 'bg-red-500';
  };
  const getStatTextColor = (value: number) => {
    if (value >= 80) return 'text-green-700';
    if (value >= 70) return 'text-green-600';
    if (value >= 60) return 'text-yellow-700';
    if (value >= 50) return 'text-orange-700';
    return 'text-red-700';
  };
  return <div className="w-full max-w-7xl mx-auto pb-12" data-id="element-962" data-mp="2auy6hi5l0sg3">
      <div className="bg-white rounded-lg shadow-sm p-4 mb-6" data-id="element-963" data-mp="262wwk2vvzdt8">
        <div className="mb-6" data-id="element-964" data-mp="260k9xcf6of9u">
          <h2 className="text-xl font-bold" data-id="element-965" data-mp="2jts1j439larj">Teams</h2>
        </div>
        <div className="flex items-center justify-between mb-4" data-id="element-966" data-mp="2jw4q403j2jdk">
          <div className="flex items-center gap-4" data-id="element-967" data-mp="2from64dh5m0z">
            <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-2 hover:bg-gray-100 rounded-md" data-id="element-968" data-mp="2ts7qb0etk7xv">
              <SidebarIcon className="w-5 h-5" data-id="element-969" data-mp="2oto55281v06k" />
            </button>
            <select value={filters.league} onChange={e => setFilters({
            ...filters,
            league: e.target.value
          })} className="rounded-md border-gray-300 text-sm" data-id="element-970" data-mp="zdey7bd59zao">
              <option value="" data-id="element-971" data-mp="3b1tkmmz1y1tl">All Leagues</option>
              {leagues.map(league => <option key={league} value={league} data-id="element-972" data-mp="2wd778qszjk50">
                  {league}
                </option>)}
            </select>
          </div>
          <button onClick={resetFilters} className="flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900" data-id="element-973" data-mp="319nu7hog7sgi">
            <FilterXIcon className="w-4 h-4 mr-2" data-id="element-974" data-mp="2sbtyo8yid2ue" />
            Reset Filters
          </button>
        </div>
      </div>
      <div className="flex gap-6" data-id="element-975" data-mp="2dfmf9auxc5g6">
        {sidebarOpen && <div className="w-64 shrink-0" data-id="element-976" data-mp="2idxr1r4s4q11">
            <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-977" data-mp="2iez4g299polx">
              <h3 className="font-semibold mb-4" data-id="element-978" data-mp="bnq78b7ytdq5">Filters</h3>
              <div className="space-y-6" data-id="element-979" data-mp="gl9hz15gf8dc">
                <div data-id="element-980" data-mp="gk84kq0yu9sg">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-981" data-mp="gjf8qk3jp4p3">
                    Search
                  </label>
                  <input type="text" value={filters.searchQuery} onChange={e => setFilters({
                ...filters,
                searchQuery: e.target.value
              })} placeholder="Search teams..." className="w-full rounded-md border-gray-300 text-sm" data-id="element-982" data-mp="2viphn8n7sf9c" />
                </div>
                <div data-id="element-983" data-mp="2cuc62npakf67">
                  <label className="flex items-center text-sm font-medium text-gray-700 mb-1" data-id="element-984" data-mp="27sd3hg1dlmab">
                    <input type="checkbox" checked={filters.showFavorites} onChange={e => setFilters({
                  ...filters,
                  showFavorites: e.target.checked
                })} className="rounded border-gray-300 text-blue-600 mr-2" data-id="element-985" data-mp="22u1x5faahtwu" />
                    Show Favorites Only
                  </label>
                </div>
                <div data-id="element-986" data-mp="icsqzwpdf0fi">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-987" data-mp="icj80t2qttjb">
                    Win Percentage
                  </label>
                  <input type="range" min="0" max="100" value={filters.winPercentage[1]} onChange={e => setFilters({
                ...filters,
                winPercentage: [0, parseInt(e.target.value)]
              })} className="w-full" data-id="element-988" data-mp="3lsq0e3fpk4cs" />
                  <div className="text-xs text-gray-500 mt-1" data-id="element-989" data-mp="1b05atz45cu54">
                    {filters.winPercentage[0]}% - {filters.winPercentage[1]}%
                  </div>
                </div>
                <div data-id="element-990" data-mp="2d7mf5r63ofw9">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-991" data-mp="2d6bfo3jotuay">
                    Offense Rating
                  </label>
                  <input type="range" min="0" max="100" value={filters.offenseRating[1]} onChange={e => setFilters({
                ...filters,
                offenseRating: [0, parseInt(e.target.value)]
              })} className="w-full" data-id="element-992" data-mp="2m07pcivo1e9h" />
                  <div className="text-xs text-gray-500 mt-1" data-id="element-993" data-mp="23cb2dee95ir5">
                    {filters.offenseRating[0]} - {filters.offenseRating[1]}
                  </div>
                </div>
                <div data-id="element-994" data-mp="3eovb0fkbu5nk">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-995" data-mp="3errbobnk78fp">
                    Defense Rating
                  </label>
                  <input type="range" min="0" max="100" value={filters.defenseRating[1]} onChange={e => setFilters({
                ...filters,
                defenseRating: [0, parseInt(e.target.value)]
              })} className="w-full" data-id="element-996" data-mp="181e9vpeq7dad" />
                  <div className="text-xs text-gray-500 mt-1" data-id="element-997" data-mp="p8k5fpeqb3ke">
                    {filters.defenseRating[0]} - {filters.defenseRating[1]}
                  </div>
                </div>
                <div data-id="element-998" data-mp="fcpe85wfw060">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-999" data-mp="fea7ls70pd2a">
                    3PT Percentage
                  </label>
                  <input type="range" min="0" max="100" value={filters.threePtPercentage[1]} onChange={e => setFilters({
                ...filters,
                threePtPercentage: [0, parseInt(e.target.value)]
              })} className="w-full" data-id="element-1000" data-mp="29pf8wpumtdeg" />
                  <div className="text-xs text-gray-500 mt-1" data-id="element-1001" data-mp="3u8irszgo4sos">
                    {filters.threePtPercentage[0]}% -{' '}
                    {filters.threePtPercentage[1]}%
                  </div>
                </div>
              </div>
            </div>
          </div>}
        <div className="flex-1" data-id="element-1002" data-mp="qppqpm52twbi">
          <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-1003" data-mp="cske13auxz7a">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1004" data-mp="cudkahhk6her">
              <thead className="bg-gray-50" data-id="element-1005" data-mp="gs1lg29uh6f3">
                <tr data-id="element-1006" data-mp="2xii5r87ooqb6">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1007" data-mp="2xi0aadsuig4b">
                    Team
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1008" data-mp="31hio6pm91qxn">
                    Win %
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1009" data-mp="2p0pxfnlr0zcf">
                    Offense Rating
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1010" data-mp="2yz5qvx890kp3">
                    Defense Rating
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1011" data-mp="26aro7467t077">
                    3PT %
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1012" data-mp="2l0yz8ytw7gxv">
                    AST
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1013" data-mp="1sijvpolyrveb">
                    REB
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1014" data-mp="qtoh0uqm0bob">
                {teams.map(team => <tr key={team.name} className="hover:bg-gray-50" data-id="element-1015" data-mp="uvi8qditu5cc">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1016" data-mp="zttiko94gfuk">
                      <div className="flex items-center" data-id="element-1017" data-mp="zrgv5vklhda4">
                        <button onClick={() => toggleFavorite(team.name)} className={`p-1 rounded-full mr-2 hover:bg-gray-100 ${favoriteTeams.includes(team.name) ? 'text-yellow-500' : 'text-gray-400'}`} data-id="element-1018" data-mp="14lbl3gqsmohn">
                          <StarIcon className="w-5 h-5" fill={favoriteTeams.includes(team.name) ? 'currentColor' : 'none'} data-id="element-1019" data-mp="1ijjcl9528xlf" />
                        </button>
                        <img src={team.logo} alt={team.name} className="w-8 h-8 mr-3" data-id="element-1020" data-mp="3pcc43uoutk1z" />
                        <div data-id="element-1021" data-mp="3cy6re55nvbki">
                          <div className="font-medium text-gray-900" data-id="element-1022" data-mp="380x1ypi9uzwo">
                            {team.name}
                          </div>
                          <div className="text-sm text-gray-500" data-id="element-1023" data-mp="333evd5rq8wru">
                            {team.conference} • {team.division}
                          </div>
                        </div>
                      </div>
                    </td>
                    {Object.entries(team.stats).map(([key, value]) => <td key={key} className="px-6 py-4 whitespace-nowrap" data-id="element-1024" data-mp="3qpv347bzzy0y">
                        <div className="flex items-center gap-3" data-id="element-1025" data-mp="3mpb5l2niisea">
                          <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-1026" data-mp="2fd0y90uac7qe">
                            <div className={`h-full ${getStatColor(value)}`} style={{
                        width: `${value}%`
                      }} data-id="element-1027" data-mp="2baee7m3uvr3r" />
                          </div>
                          <span className={`text-sm font-medium ${getStatTextColor(value)}`} data-id="element-1028" data-mp="22u5lrqzo0969">
                            {value.toFixed(1)}
                          </span>
                        </div>
                      </td>)}
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};
export default TeamsTable;